import React from 'react';
import { TargetIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
export function SimpleEngineOverview() {
  const systems = [{
    icon: TargetIcon,
    title: 'The Recruiting Engine',
    tagline: 'Predictable applicant flow',
    description: 'Stop gambling on job boards. We help you install a cold-market sourcing system designed to generate consistent, qualified applicants each month.',
    benefits: ['Targeted, role-specific messaging', 'Campaign strategy and positioning guidance', 'Automated screening and qualification support', 'Predictable monthly interview volume']
  }, {
    icon: ShieldCheckIcon,
    title: 'The Retention Engine',
    tagline: 'Turn hires into launches',
    description: 'Most reps quit in the first 8 weeks. We help build the structure, communication, and accountability that get rookies to their first wins and beyond.',
    benefits: ['Structured onboarding pathway', 'Early-stage engagement checkpoints', 'Support systems for mindset, expectations, and performance', 'Increased Week 1–8 resilience and retention'],
    disclaimer: '(Note: Results vary by company and leadership engagement.)'
  }, {
    icon: TrendingUpIcon,
    title: 'The Results Engine',
    tagline: 'Rookies to producers',
    description: 'Launch is only the beginning. The system supports leadership with training frameworks and live weekly sales schools that accelerate development and increase long-term value.',
    benefits: ['Skill and behavioral reinforcement', 'Performance tracking guidance', 'Role clarity and development planning', 'Scalable framework for team consistency']
  }];
  return <section className="section-padding bg-gray-50" data-id="element-906">
      <div className="container-custom" data-id="element-907">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-908">
          <h2 className="mb-6" data-id="element-909">The Three-Part HIRE System</h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-910">
            Each part of the system is designed to solve a specific problem in
            the recruiting and early-retention cycle. Together, they create
            consistency, stability, and predictable growth.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-911">
          {systems.map((system, index) => {
          const Icon = system.icon;
          return <div key={index} className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-200 hover:border-slate transition-all" data-id="element-912">
                <div className="w-16 h-16 bg-gradient-slate rounded-xl flex items-center justify-center mb-6" data-id="element-913">
                  <Icon className="h-8 w-8 text-white" data-id="element-914" />
                </div>
                <h3 className="text-2xl mb-2" data-id="element-915">{system.title}</h3>
                <p className="text-slate font-semibold mb-4" data-id="element-916">
                  {system.tagline}
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-917">
                  {system.description}
                </p>
                <div className="mb-4" data-id="element-918">
                  <p className="text-sm font-semibold text-navy mb-3" data-id="element-919">
                    Includes:
                  </p>
                  <ul className="space-y-3" data-id="element-920">
                    {system.benefits.map((benefit, idx) => <li key={idx} className="flex items-start text-sm text-gray-700" data-id="element-921">
                        <span className="text-slate mr-2 flex-shrink-0 font-bold" data-id="element-922">
                          ✓
                        </span>
                        {benefit}
                      </li>)}
                  </ul>
                </div>
                {system.disclaimer && <p className="text-xs text-gray-500 italic mt-4" data-id="element-923">
                    {system.disclaimer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}